export function initCarrerasFilter() {

  const root = document.querySelector('[data-livefilter-root]');
  if (!root) return;

  const input  = root.querySelector('[data-livefilter]');
  const reset  = root.querySelector('[data-livefilter-reset]');
  const empty  = document.querySelector('[data-livefilter-empty]');
  const facultades = document.querySelectorAll('[data-facultad]');

  if (!input || !facultades.length) return;

  const normalize = (s) => (s || '')
    .toString()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();

  const apply = () => {

    const q = normalize(input.value.trim());

    root.classList.toggle('_has-value', input.value.length > 0);

    if (!q) {
      facultades.forEach(f => {
        f.hidden = false;
        f.querySelectorAll('[data-search]').forEach(c => { c.hidden = false; });
      });
      if (empty) empty.hidden = true;
      return;
    }

    let anyVisible = false;

    facultades.forEach(facultadEl => {

      const facultadMatch = normalize(facultadEl.dataset.facultad).includes(q);
      const cards = facultadEl.querySelectorAll('[data-search]');
      let facultadHasMatch = false;

      cards.forEach(card => {
        const match = facultadMatch || normalize(card.dataset.search).includes(q);
        card.hidden = !match;
        if (match) facultadHasMatch = true;
      });

      facultadEl.hidden = !facultadHasMatch;
      if (facultadHasMatch) anyVisible = true;

    });

    if (empty) empty.hidden = anyVisible;

  };

  input.addEventListener('input', apply);

  if (reset) {
    reset.addEventListener('click', () => {
      input.value = '';
      apply();
      input.focus();
    });
  }

}
